module.exports = __webpack_public_path__ + "img/Logotipo Chronos.f1cdfc16.svg";